import { NgModule } from '@angular/core';
import { GlobalPopupModule } from '../global-popup';
import { DocumentsModule } from './../documents/documents.module';
import { GeneralDocumentsTabsComponent } from './general-documents-tabs.component';
import { GeneralDocumentsWithCategoriesComponent } from './general-documents-with-categories.component';
import { GeneralDocumentsComponent } from './general-documents.component';
import { GeneralReportsStorage } from './general-reports-storage';
import { GeneralUnreadReportsStorage } from './general-unread-reports-storage';
import { GeneralLevelComponent } from './general-level.component';

@NgModule({
    imports: [
        GlobalPopupModule,
        DocumentsModule,
    ],
    declarations: [
        GeneralDocumentsTabsComponent,
        GeneralDocumentsWithCategoriesComponent,
        GeneralDocumentsComponent,
        GeneralLevelComponent,
    ],
    exports: [
        GeneralDocumentsTabsComponent,
        GeneralDocumentsWithCategoriesComponent,
        GeneralDocumentsComponent,
    ],
    providers: [
        GeneralReportsStorage,
        GeneralUnreadReportsStorage,
    ],
})
export class GeneralDocumentsModule { }
